import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAvatarPlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4_186)",
		children: /* @__PURE__ */ _jsx("rect", {
			x: .6,
			y: .6,
			width: 16.8,
			height: 16.8,
			rx: 8.4,
			stroke: "#C5C5C5",
			strokeWidth: 1.2,
			strokeDasharray: "1.4 1.4"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4_186",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			rx: 9,
			fill: "white"
		})
	}) })]
});
export default SvgIconAvatarPlaceholder;
